import { render, staticRenderFns } from "./Dash-overview-many.vue?vue&type=template&id=34a33f79"
import script from "./Dash-overview-many.vue?vue&type=script&lang=js"
export * from "./Dash-overview-many.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports